export const DEFAULT_PODCAST_ARTWORK_URL = "https://storage.googleapis.com/podpal-podcast-photos/1/1"
